import { __assign } from "tslib";
import get from 'lodash/get';
import { reduxKey } from './constants';
import { flagEnabled } from '../../redux/flags';
export function getSiteHeaderState(state) {
    var headerState = get(state, reduxKey, {
        isSearchPopupShown: false,
        isNotificationsDropdownOpen: false,
        isUserDropdownOpen: false,
    });
    if (flagEnabled(state, 'force_notifs_open')) {
        headerState = __assign(__assign({}, headerState), { isNotificationsDropdownOpen: true });
    }
    return headerState;
}
//# sourceMappingURL=selectors.js.map